/* ===========================================================================
   Façade de lecture YouTube — Book Nook Store                    2026-09-15
   ---------------------------------------------------------------------------
   POURQUOI : 53 descriptions produit contiennent une iframe YouTube. Un lecteur
   YouTube peint un aplat NOIR avant de charger, d'où le gros carré noir pendant
   le chargement de la fiche. `loading="lazy"` ne suffisait pas : l'accordéon
   « Product Details » est ouvert par défaut, l'iframe se retrouve donc dans le
   viewport au chargement et le navigateur la charge quand même.

   COMMENT : le thème sert désormais ces iframes avec `data-src` au lieu de
   `src` (voir sections/main-product.liquid). Sans `src`, l'iframe ne fait
   AUCUNE requête et ne peint rien — le carré noir ne peut plus exister.
   Ce script pose à la place une vignette + un bouton lecture, et n'injecte la
   vraie iframe qu'au clic.

   EFFETS DE BORD BÉNÉFIQUES :
   - ~1 Mo de moins par fiche produit (le lecteur YouTube n'est plus chargé) ;
   - le SON fonctionne : `autoplay=1` posé DANS un gestionnaire de clic est un
     geste utilisateur, donc le navigateur autorise le son (un autoplay sans
     geste serait forcé en muet) ;
   - le nom de la chaîne « Book Nook France » n'apparaît plus au chargement,
     puisque l'habillage YouTube n'existe qu'après le clic.
   =========================================================================== */
(function () {
  'use strict';

  function videoId(url) {
    var m = String(url).match(/\/embed\/([A-Za-z0-9_-]{6,})/);
    return m ? m[1] : null;
  }

  function withAutoplay(url) {
    // autoplay + son, et on limite l'habillage YouTube au strict nécessaire
    var extra = 'autoplay=1&rel=0&modestbranding=1&playsinline=1';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + extra;
  }

  function build(iframe) {
    var src = iframe.getAttribute('data-src');
    var id = videoId(src);
    if (!src || !id || iframe.dataset.facadeDone) return;
    iframe.dataset.facadeDone = '1';

    var wrap = document.createElement('div');
    wrap.className = 'yt-facade';

    var img = document.createElement('img');
    img.className = 'yt-facade__thumb';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.alt = iframe.getAttribute('title') || 'Play the video';
    img.src = 'https://i.ytimg.com/vi/' + id + '/maxresdefault.jpg';
    // toutes les vidéos n'ont pas de maxres : repli sur hqdefault.
    // ⚠️ (13/10) YouTube répond 404 AVEC une image grise de 120 × 90 px : le
    // navigateur l'affiche et déclenche `load`, pas `error`. On teste donc aussi
    // la largeur réelle (une vraie maxres fait 1280 px).
    function fallback() {
      if (img.dataset.fallback) return;
      img.dataset.fallback = '1';
      img.src = 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg';
    }
    img.addEventListener('error', fallback);
    img.addEventListener('load', function () {
      if (!img.dataset.fallback && img.naturalWidth <= 120) fallback();
    });

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'yt-facade__btn';
    btn.setAttribute('aria-label', 'Play the video');
    btn.innerHTML =
      '<svg viewBox="0 0 68 48" aria-hidden="true" focusable="false">' +
      '<path class="yt-facade__btn-bg" d="M66.5 7.7c-.8-2.9-2.5-5.4-6-6.1C55.6.2 34 0 34 0S12.4.2 7.5 1.6c-3.5.7-5.2 3.2-6 6.1C.2 12.6 0 24 0 24s.2 11.4 1.5 16.3c.8 2.9 2.5 5.4 6 6.1C12.4 47.8 34 48 34 48s21.6-.2 26.5-1.6c3.5-.7 5.2-3.2 6-6.1C67.8 35.4 68 24 68 24s-.2-11.4-1.5-16.3z"/>' +
      '<path d="M45 24 27 14v20z" fill="#fff"/></svg>';

    wrap.appendChild(img);
    wrap.appendChild(btn);

    // on conserve la hauteur voulue par le contenu quand elle est en pixels,
    // sinon on retombe sur un 16/9 — évite tout saut de mise en page.
    var h = iframe.getAttribute('height');
    if (h && /^\d+(px)?$/.test(h)) wrap.style.setProperty('--yt-h', parseInt(h, 10) + 'px');

    iframe.parentNode.insertBefore(wrap, iframe);
    iframe.style.display = 'none';

    function play() {
      iframe.setAttribute('src', withAutoplay(src));
      iframe.removeAttribute('data-src');
      iframe.style.display = '';
      iframe.classList.add('yt-facade__live');
      if (h && /^\d+(px)?$/.test(h)) iframe.style.height = parseInt(h, 10) + 'px';
      wrap.parentNode.removeChild(wrap);
      // le focus part sur le lecteur : utile au clavier
      try { iframe.focus({ preventScroll: true }); } catch (e) {}
    }

    wrap.addEventListener('click', play);
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); play(); }
    });
  }

  function scan(root) {
    (root || document).querySelectorAll('iframe[data-src*="youtube"], iframe[data-src*="youtu.be"]').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
  // le thème recharge des morceaux de section (changement de variante, etc.)
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes.length) { scan(); break; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
